import { Card } from '@ui';
import { FormController, FormInput, FormTextArea } from '@/components/form';
import { Badge, Box, Flex, Text } from '@chakra-ui/react';
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { LuDot } from 'react-icons/lu';
import z from 'zod';

const ChooseTrailer = () => {
  return (
    <Card fontSize="sm">
      <Flex flexDirection="column" gapY={4}>
        <Text fontWeight="bold">1. Choose trailer</Text>
        <Text color="fg.subtle">
          Pick the trailer you want to work on, then fill in basic details.
        </Text>

        <Flex flexDirection="column" gapY={2}>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between">
                <Text fontWeight="bold">Trailer #12 - Stop 1</Text>
                <Badge color="orange.emphasized" bg="orange.200">
                  <Text>Draft</Text>
                </Badge>
              </Flex>
              <Flex
                justifyContent="space-between"
                fontSize="xs"
                color="fg.subtle"
              >
                <Flex alignItems="center">
                  <Text>2 crates</Text>
                  <LuDot />
                  <Text>Site A L5</Text>
                </Flex>
                <Flex alignItems="center">
                  <Text>30%</Text>
                  <LuDot />
                  <Text>512 kg</Text>
                </Flex>
              </Flex>
            </Flex>
          </Card>
          <Card>
            <Flex flexDirection="column" gapY={2}>
              <Flex justifyContent="space-between">
                <Text fontWeight="bold">Trailer #12 - Stop 1</Text>
                <Badge color="orange.emphasized" bg="orange.200">
                  <Text>Draft</Text>
                </Badge>
              </Flex>
              <Flex
                justifyContent="space-between"
                fontSize="xs"
                color="fg.subtle"
              >
                <Flex alignItems="center">
                  <Text>2 crates</Text>
                  <LuDot />
                  <Text>Site A L5</Text>
                </Flex>
                <Flex alignItems="center">
                  <Text>30%</Text>
                  <LuDot />
                  <Text>512 kg</Text>
                </Flex>
              </Flex>
            </Flex>
          </Card>
        </Flex>

        <Card>
          <Flex>
            <FormController
              formSchema={chooseTrailerSchema}
              onFormSubmit={() => {}}
              defaultValues={{
                carrier: '',
                driverName: '',
                phoneNumber: '',
                truckPlateNumber: '',
                date: '',
                notes: '',
              }}
              buttonProps={{
                hidden: true,
              }}
            >
              {({
                register,
                control,
                errors,
              }: {
                register: UseFormRegister<FormData>;
                control: Control<FormData>;
                errors: FieldErrors<FormData>;
              }) => {
                return (
                  <Flex flexDirection="column" gapY={4}>
                    <Flex>
                      <Box>
                        <FormInput
                          control={control}
                          label="Carrier"
                          id="carrier"
                          register={register}
                          errors={errors}
                          maxWidth="200px"
                          showLabelAtTop
                        />
                      </Box>
                      <Box>
                        <FormInput
                          control={control}
                          label="Driver Name"
                          id="driverName"
                          register={register}
                          errors={errors}
                          maxWidth="200px"
                          showLabelAtTop
                        />
                      </Box>
                      <Box>
                        <FormInput
                          control={control}
                          label="Phone"
                          id="phoneNumber"
                          register={register}
                          errors={errors}
                          maxWidth="200px"
                          showLabelAtTop
                        />
                      </Box>
                    </Flex>
                    <Flex>
                      <Box>
                        <FormInput
                          control={control}
                          label="Truck plate"
                          id="truckPlateNumber"
                          register={register}
                          errors={errors}
                          maxWidth="200px"
                          showLabelAtTop
                        />
                      </Box>
                      <Box>
                        <FormInput
                          control={control}
                          label="Date"
                          id="date"
                          type="date"
                          register={register}
                          errors={errors}
                          maxWidth="200px"
                          showLabelAtTop
                        />
                      </Box>
                    </Flex>
                    <FormTextArea
                      control={control}
                      register={register}
                      errors={errors}
                      label="Notes"
                      id="notes"
                      showLabelAtTop
                      minHeight="5lh"
                      maxHeight="5lh"
                    />
                  </Flex>
                );
              }}
            </FormController>
          </Flex>
        </Card>
      </Flex>
    </Card>
  );
};
export default ChooseTrailer;

const chooseTrailerSchema = z.object({
  carrier: z.string(),
  driverName: z.string(),
  phoneNumber: z.string(),
  truckPlateNumber: z.string(),
  date: z.string(),
  notes: z.string().optional(),
});
type FormData = z.infer<typeof chooseTrailerSchema>;
